import {
  updateResourceState,
  createResourceReducer,
  RESOURCE,
  RECORD_FIELD
} from '@unicus/react-ui-kit';
import {
  COMPANY,
  COMPANY_CANCEL,
  COMPANY_GET,
  COMPANY_GET_FINISHED,
  COMPANY_GET_SETTINGS,
  COMPANY_GET_SETTINGS_FINISHED,
  COMPANY_GET_SETUP_STEPS,
  COMPANY_GET_SETUP_STEPS_FINISHED,
  COMPANY_UPDATE,
  COMPANY_UPDATE_FINISHED,
  COMPANY_SETTINGS_UPDATE,
  COMPANY_SETTINGS_UPDATE_FINISHED,
  COMPANY_UPLOAD_CERTIFICATE,
  COMPANY_UPLOAD_CERTIFICATE_ERROR,
  COMPANY_UPLOAD_CERTIFICATE_FINISHED
} from './companyActions';

const companyReducer = createResourceReducer(COMPANY, [], {
  [COMPANY_GET](state, action) {
    return updateResourceState(state, action, RESOURCE, () => ({
      loading: true,
      tab: action.payload.tab
    }));
  },

  [COMPANY_GET_FINISHED](state, action) {
    return updateResourceState(state, action, RESOURCE, () => ({
      [RECORD_FIELD]: action.payload.data.result,
      loading: false,
      visible: true
    }));
  },

  [COMPANY_GET_SETTINGS](state, action) {
    return updateResourceState(state, action, RESOURCE, () => ({
      loadingEdition: true
    }));
  },

  [COMPANY_GET_SETTINGS_FINISHED](state, action) {
    return updateResourceState(state, action, RESOURCE, () => ({
      editingSettings: action.payload.data.result,
      loadingEdition: false
    }));
  },

  [COMPANY_UPDATE](state, action) {
    return updateResourceState(state, action, RESOURCE, () => ({
      [RECORD_FIELD]: action.payload,
      saving: true
    }));
  },

  [COMPANY_UPDATE_FINISHED](state, action) {
    return updateResourceState(state, action, RESOURCE, () => ({
      [RECORD_FIELD]: null,
      saving: false,
      visible: false,
      tab: null
    }));
  },

  [COMPANY_SETTINGS_UPDATE](state, action) {
    return updateResourceState(state, action, RESOURCE, () => ({
      editingSettings: action.payload,
      saving: true
    }));
  },

  [COMPANY_SETTINGS_UPDATE_FINISHED](state, action) {
    return updateResourceState(state, action, RESOURCE, () => ({
      editingSettings: action.payload.data.result,
      loading: false,
      saving: false
    }));
  },

  [COMPANY_CANCEL](state, action) {
    return updateResourceState(state, action, RESOURCE, () => ({
      [RECORD_FIELD]: null,
      loading: false,
      saving: false,
      visible: false
    }));
  },

  [COMPANY_UPLOAD_CERTIFICATE](state, action) {
    return updateResourceState(state, action, RESOURCE, () => ({
      uploading: true
    }));
  },

  [COMPANY_UPLOAD_CERTIFICATE_FINISHED](state, action) {
    return updateResourceState(state, action, RESOURCE, (resource) => ({
      uploading: false
    }));
  },

  [COMPANY_UPLOAD_CERTIFICATE_ERROR](state, action) {
    return updateResourceState(state, action, RESOURCE, () => ({
      uploading: false
    }));
  },

  [COMPANY_GET_SETUP_STEPS](state, action) {
    return updateResourceState(state, action, RESOURCE, () => ({
      loading: true
    }));
  },

  [COMPANY_GET_SETUP_STEPS_FINISHED](state, action) {
    return updateResourceState(state, action, RESOURCE, () => ({
      setupSteps: action.payload.data.result,
      loading: false
    }));
  }
});

export default companyReducer;
